import { observable, action, runInAction } from 'mobx';
import { PAGE_SIZE_DEFAULT } from '../constants/appConstant';
import alertMessage from '../utils/alertMessage'
import apiToolsAPI from '../apis/apiToolsAPI' 
import mappingManagementAPI from '../apis/mappingManagementAPI'
import apiManagementAPI from '../apis/apiManagementAPI'

export default class ApiToolsStore {
  constructor(rootStore) {
      this.rootStore = rootStore;
  }
  @observable isFetching = false;
  @observable pageSize = PAGE_SIZE_DEFAULT;
  @observable pageNo = 1;
  @observable currIndex = 0
  @observable itemCount = 0;

  /*Transportation start*/
  /*SearchResult start*/
  @observable searchItem = {
    apiName: "",
    transportationDataType: ""
  }
  @observable resultList = []
  @action
  async onSearchTransportationAction(params) {
    this.isFetching = true
    try {
      let response = null
      if(params.transportationDataType==='MAPPING'){
        response = await mappingManagementAPI.detailsAction(params.id)
      }else{
        response = await apiManagementAPI.getDetailAction(params.id)
      }
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          const dataObj = response.data.data
          const resultItem = {
            apiName: params.transportationDataType==='MAPPING'? dataObj.name : dataObj.apiName,
            apiType: params.transportationDataType==='MAPPING'? dataObj.mappingType : dataObj.customerStr,
            id: dataObj.id,
            transportationDataType: params.transportationDataType
          }
          let itemObj = null
          itemObj = this.resultList.find(item => {
            return item.id === dataObj.id;
          });
          if(itemObj===undefined){
            this.resultList.push(resultItem)
          }else{
            alertMessage.error('Object Name already exists！')
          }
          this.searchItem = params
        } else {
          alertMessage.error('Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  @action
  onChangeResultList(value){
    this.resultList=value
  }
  /*selectedRowKeys*/
  @observable selectedRowKeys=[]
  @observable selectedRows=[]
  @action
  onChangeSelectedRowKeys(selectedRowKeys,selectedRows){
    this.selectedRowKeys=selectedRowKeys
    this.selectedRows=selectedRows
  }
  /*export*/
  @action
  async onExportAction(params) {
    this.isFetching = true
    try {
      const response = await apiToolsAPI.exportAction(params)
      runInAction(() => {
        this.isFetching = false;
        if (!Array.isArray(response.data) && response.data?.code !== 200) {
          alertMessage.error('Failed！' + response.data.messageEn +'')
        }
      })
      return response
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*Transportation end*/


  /*Mass Resend start*/
  /*resend*/
  @observable resendList=[]
  @action
  async onResendAction(apiName,apiType,direction,params) {
    this.isFetching = true
    this.resendList = []
    try {
      const response = await apiToolsAPI.resendAction(apiName,apiType,direction,params)
      runInAction(() => {
        this.isFetching = false;
        if (response.data.code === 0) {
          alertMessage.success('Success！')
          this.resendList = response.data.data
        } else {
          alertMessage.error('Failed！' + response.data.messageEn +'')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false;
      });
    }
  }
  /*change resendList*/
  @action
  onChangeResendList(value){
    this.resendList=value
  }
  /*Mass Resend end*/
}
